<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">회원관리</span>
            <span class="txt">
                센터에 등록한 회원님을 검색하실 수 있으며, 회원님의 성함을 눌러 이용권 등록 및 마일리지 등록 등 회원님의
                다양한 설정을 진행하실 수 있습니다.
            </span>
        </div>
        <loading-spinner v-if="isLoading"></loading-spinner>
        <template v-else>
            <div style="display: flex; gap: 28px">
                <div class="photo-info-card">
                    <img
                         class="photo"
                         :src="customerInfo.imageUrl === null ? defaultImageUrl : customerInfo.imageUrl"
                         alt="사진"
                    />
                    <div class="info-txt">
                        <span class="txt name">{{ customerInfo.name + ` (${customerInfo.attendNo})` }}</span>
                        <span class="txt">{{ customerInfo.phone | phoneNumberFilter }}</span>
                        <span class="txt">{{ convertTeamGroupsToString(customerInfo.centerCustomerTeamGroups) }}</span>
                        <span class="txt">-</span>
                    </div>
                    <span v-if="customerInfo.status === 'V'" class="icon green">유효</span>
                    <span v-if="customerInfo.status === 'E'" class="icon red">만료</span>
                    <span v-if="customerInfo.status === '-'" class="icon gray">잠재</span>
                    <span v-if="customerInfo.status === 'H'" class="icon yellow">홀딩</span>
                    <!--<button class="send-btn">인증코드전송</button>-->
                </div>
                <div class="d-flex flex-column" style="margin-top: 35px">
                    <button
                        v-if="hasMessageEvent && customerInfo.mktAgreeSms"
                        class="com-btn deep-blue left"
                        @click="routing('messageSend', customerInfo)"
                    >
                        메시지 발송
                    </button>
                    <button
                        v-show="isAllowed('ME', 6)"
                        class="com-btn white"
                        style="margin-top: 10px"
                        @click="showContractSendPopup()"
                    >
                        계약서 발송
                    </button>
                </div>

                <div class="info-card">
                    <div class="info-txt">
                        <span class="txt name">최근 수업일</span>
                        <span class="txt">{{ lastLessonDaysAgo }}일전</span>
                        <span class="txt">마지막 출석: {{ customerInfo.latestLessonAt | dateFormatFilter }}</span>
                    </div>
                </div>
            </div>
            <div class="com-tab">
                <button class="on">기본정보</button>
                <button @click="onClickRouter('/madmin/member/payment')">결제내역</button>
                <button @click="onClickRouter('/madmin/member/cancel')">예약/취소내역</button>
                <button @click="onClickRouter('/madmin/member/attend')">입장/출결내역</button>
                <button @click="onClickRouter('/madmin/member/mileage')">마일리지</button>
                <button
                    @click="
                        checkAllowedClick('MB', 3, () => {
                            onClickRouter('/madmin/member/advice');
                        })
                    "
                >
                    상담내역
                </button>
                <button @click="onClickRouter('/madmin/member/message')">메시지발송내역</button>
                <button v-show="isAllowed('ME', 7)" @click="onClickRouter('/madmin/member/contract_send')">
                    계약서발송내역
                </button>
            </div>

            <div class="com-table-wrap">
                <div class="com-card-input half-type">
                    <div class="left-box">
                        <div class="line">
                            <span class="tit">센터</span>
                            <div class="input-cnt">
                                <select-form
                                    :select-data="['선택', ...chainCenterType]"
                                    :select-value="['', ...chainCenterTypeValue]"
                                    :selected-value="centerId"
                                    class="w220"
                                    @update:set="(val) => (centerId = val)"
                                ></select-form>
                            </div>
                        </div>
                        <div class="line">
                            <div class="division">
                                <span class="tit">
                                    회원명
                                    <span class="imp">*</span>
                                    <small>(반드시 본명 입력)</small>
                                </span>
                                <div class="input-cnt">
                                    <input v-model="editField.name" class="w220" maxlength="10" type="text" />
                                </div>
                            </div>
                            <div class="division">
                                <span class="tit">닉네임</span>
                                <div class="input-cnt">
                                    <input
                                        v-model="editField.nickName"
                                        class="w220"
                                        maxlength="10"
                                        placeholder="닉네임아이디"
                                        type="text"
                                    />
                                </div>
                            </div>
                            <p class="notice-txt">
                                ※ 이름과 연락처는 회원 APP 사용 시 센터이용권을 연동하는 정보로 사용되므로
                                <br />
                                반드시 본명을 입력해 주세요.
                                <br />
                                앱 연동 이후에는 수정이 불가합니다.
                            </p>
                        </div>
                        <div class="line">
                            <span class="tit">
                                연락처
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <input
                                        v-model="editField.phone[0]"
                                        maxlength="3"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <input
                                        v-model="editField.phone[1]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <input
                                        v-model="editField.phone[2]"
                                        maxlength="4"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangePhoneNumber"
                                    />
                                    <div>
                                        <btn-loading-spinner v-if="isProgressPhoneCheck"></btn-loading-spinner>
                                        <button v-else class="com-btn" @click="checkDuplicatePhone">중복확인</button>
                                    </div>

                                    <span
                                        v-if="showPhoneCheckMsg === true || showPhoneCheckMsg === false"
                                        :class="{ error: true, red: !showPhoneCheckMsg, green: showPhoneCheckMsg }"
                                    >
                                        {{ showPhoneCheckMsg === true ? '사용 가능합니다.' : '중복된 번호입니다.' }}
                                    </span>
                                </div>
                            </div>
                            <div class="sub">
                                <div class="com-check">
                                    <input
                                        id="phone-check-1"
                                        v-model="editField.parentTelNoYn"
                                        name="phone-check"
                                        type="checkbox"
                                    />
                                    <label for="phone-check-1">보호자 연락처</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">현금영수증</span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <input v-model="editField.taxTelNo[0]" maxlength="3" type="text" />
                                    <input v-model="editField.taxTelNo[1]" maxlength="4" type="text" />
                                    <input v-model="editField.taxTelNo[2]" maxlength="4" type="text" />
                                </div>
                            </div>
                            <div class="sub">
                                <div class="com-check">
                                    <input
                                        id="phone-check-2"
                                        v-model="equalPhoneAndTaxNo"
                                        name="phone-check-2"
                                        type="checkbox"
                                    />
                                    <label for="phone-check-2">연락처와 동일</label>
                                </div>
                            </div>
                        </div>

                        <div class="line">
                            <span class="tit">
                                성별
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-radio">
                                    <input
                                        id="radio-1-2"
                                        v-model="editField.sex"
                                        name="radio-1"
                                        type="radio"
                                        value="W"
                                    />
                                    <label for="radio-1-2">여성</label>
                                </div>
                                <div class="com-radio">
                                    <input
                                        id="radio-1-1"
                                        v-model="editField.sex"
                                        name="radio-1"
                                        type="radio"
                                        value="M"
                                    />
                                    <label for="radio-1-1">남성</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">생년월일</span>
                            <div class="input-cnt">
                                <single-calendar
                                    :date="editField.birthday"
                                    class="w220"
                                    @update="(val) => (editField.birthday = val)"
                                ></single-calendar>
                                <input
                                    maxlength="8"
                                    placeholder="직접입력(YYYYMMDD)"
                                    type="text"
                                    @keypress="isNumber($event)"
                                    @keyup="onChangeBirthDayTyping($event)"
                                />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">회원그룹</span>
                            <div class="input-cnt">
                                <select-check-form
                                    :select-data="[...memberGroupList]"
                                    :select-value="[...memberGroupValueList]"
                                    :selected-value="selectedMemberGroup"
                                    class="w435"
                                    title="선택"
                                    @update:set="onChangeMemberGroup"
                                ></select-check-form>
                            </div>
                        </div>
                    </div>
                    <div class="right-box">
                        <div class="line">
                            <span class="tit">사진</span>
                            <div class="input-cnt photo-line">
                                <div class="photo">
                                    <img
                                        :src="editField.imageUrl || defaultImageUrl"
                                        alt="사진"
                                    />
                                </div>
                                <div class="info-txt">
                                    <div>
                                        <b-form-file
                                            ref='imageFileInput'
                                            id="file1"
                                            accept=".jpg, .png, .gif"
                                            plain
                                            @change="handleImage"
                                            hidden
                                        />
                                        <label class="com-btn" for="file1">파일첨부</label>
                                    </div>

                                    <button v-if='centerInfo.activeDoorCount' class="com-btn" @click="$modal.show('camera')">사진촬영</button>

                                    <button v-if='centerInfo.activeDoorCount' class="com-btn white" @click="deleteFace">사진삭제</button>
                                </div>
                            </div>

                            <div style='margin-top: 6px;'>
                                <span class="txt" style='font-size: 12px; color: #7e7777;'>※ 권장 이미지 : 정사각형 사이즈, JPG, PNG 가능</span>
                            </div>
                        </div>

                        <div class='line' v-if='centerInfo.totalDoorCount'>
                            <div style='display: flex; flex-direction: row; align-items: center; line-height: 32px;'>
                                <span class="tit">얼굴인식</span>

                                <span v-if='faceInProgress' class='app-txt' style='margin-left: 20px;'>처리중...</span>

                                <span  v-else :class="{'app-txt': true, 'blue': customerInfo.doorRegStatus === 0}" style='margin-left: 20px;'>
                                    {{ customerInfo.doorRegStatus === 0 ? '사용중' : !customerInfo.doorRegStatus ? '미사용' : `미사용 (${DOOR_REG_ERR_MSG[customerInfo.doorRegStatus]})` }}
                                </span>
                            </div>
                        </div>

                        <div class="line">
                            <span class="tit">
                                출석체크번호
                                <span class="imp">*</span>
                            </span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <!-- 임의로 추가 -->
                                    <input
                                        v-model="editField.attendNo"
                                        class="w220"
                                        maxlength="10"
                                        type="text"
                                        @keypress="isNumber($event)"
                                        @keyup="onChangeAttendNo"
                                    />
                                    <div>
                                        <btn-loading-spinner v-if="isProgressAttendNoCheck"></btn-loading-spinner>
                                        <button v-else class="com-btn" @click="checkDuplicateAttendNo">중복확인</button>
                                    </div>
                                    <span
                                        v-if="showAttendNoCheckMsg"
                                        :class="{
                                            error: true,
                                            red: !showAttendNoCheckMsg,
                                            green: showAttendNoCheckMsg,
                                        }"
                                    >
                                        {{ showAttendNoCheckMsg ? '사용 가능합니다.' : '중복된 번호입니다.' }}
                                    </span>
                                </div>
                                <!-- 임의로 추가 -->
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">이메일</span>
                            <div class="input-cnt">
                                <div class="com-email">
                                    <input
                                        v-model="editField.email[0]"
                                        class="first"
                                        disabled
                                        maxlength="12"
                                        type="text"
                                    />
                                    <span class="txt">@</span>
                                    <input
                                        v-model="editField.email[1]"
                                        class="last"
                                        disabled
                                        maxlength="12"
                                        type="text"
                                    />
                                    <select-form
                                        :select-data="['직접 입력', ...emailTypeList]"
                                        :select-value="['', ...emailTypeValueList]"
                                        disabled
                                        @update:set="(val) => onChangeEmailSelect(val)"
                                    ></select-form>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">비밀번호 변경</span>
                            <div class="input-cnt">
                                <div class="com-tel select-type">
                                    <!-- 임의로 추가 -->
                                    <input
                                        v-model="password"
                                        class="w220"
                                        maxlength="20"
                                        type="password"
                                        placeholder="비밀번호를 입력해 주세요"
                                    />
                                    <button v-if="isAllowed('MB', 1)" class="com-btn" @click="initPassword()">
                                        변경
                                    </button>
                                </div>
                            </div>
                            <div>
                                <span id="password-notice" class="notice-txt" style="color: red !important"></span>
                            </div>
                        </div>
                        <div class="line">
                            <span v-if="editField.appUseAuthYn" class="tit">
                                APP 가입여부
                                <span class="app-txt blue">사용중</span>
                                (아이디 : {{ editField.email.join('@') }})
                            </span>
                            <span v-else class="tit">
                                APP 가입여부
                                <span class="app-txt">미사용</span>
                            </span>
                        </div>
                        <!-- <div class="line">
                            <span class="tit">비밀번호 <span class="imp">*</span></span>
                            <div class="input-cnt">
                                <input type="password" class="w220" v-model="editField.password" maxlength="15">
                            </div>
                        </div> -->
                        <div class="line">
                            <span class="tit">주소</span>
                            <div class="input-cnt">
                                <input
                                    v-model="editField.address"
                                    class="max-400 calc-100"
                                    readonly
                                    type="text"
                                    @click="postPop = true"
                                />
                                <button class="com-btn" @click="postPop = true">주소검색</button>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">상세주소</span>
                            <div class="input-cnt">
                                <input v-model="editField.addressDetail" class="w400" maxlength="30" type="text" />
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">마케팅 동의여부</span>
                            <div class="input-cnt">
                                <div class="com-check">
                                    <input
                                        id="check-1-1"
                                        v-model="editField.mktAgreeEmail"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label for="check-1-1">이메일</label>
                                </div>
                                <div class="com-check">
                                    <input
                                        id="check-1-2"
                                        v-model="editField.mktAgreeSms"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label for="check-1-2">SMS/MMS</label>
                                </div>
                                <div class="com-check">
                                    <input
                                        id="check-1-3"
                                        v-model="editField.mktAgreePush"
                                        name="check-1"
                                        type="checkbox"
                                    />
                                    <label for="check-1-3">PUSH</label>
                                </div>
                            </div>
                        </div>
                        <div class="line">
                            <span class="tit">
                                메모 ({{ lodash.get(editField, 'memo.length', 0) | numberFormatFilter }} /
                                {{ MEMO_MAX_LEN | numberFormatFilter }})
                            </span>
                            <div class="input-cnt">
                                <textarea
                                    v-model="editField.memo"
                                    class="com-textarea w400"
                                    :maxlength="MEMO_MAX_LEN"
                                ></textarea>
                            </div>
                        </div>
                        <div v-if="isInsteadOfAdmin">
                            <div class="line">
                                <span class="tit">유저 활성화(매칭 이슈)</span>
                                <button class="com-btn blue" @click="onClickEnableUser">활성화</button>
                            </div>
                            <div class="line">
                                <span class="tit">비밀번호 변경</span>
                                <button class="com-btn blue" @click="onClickResetPassword">변경</button>
                            </div>
                            <div class="line">
                                <span class="tit">이메일 수정</span>
                                <button class="com-btn blue" @click="updateEmail">수정</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="bottom-btn">
                <button class="com-btn" @click="onClickCancleBtn">취소</button>
                <button v-if="isAllowed('MB', 1)" class="com-btn blue" @click="onClickModifyBtn">저장</button>
            </div>
        </template>
        <!-- 주소 검색 레이어 팝업 -->
        <div v-if="postPop === true" class="layer-pop square">
            <div class="view-content w600">
                <button class="close" @click="postPop = false"><span class="blind">팝업 닫기</span></button>
                <div class="scroll-area com-scroll-y">
                    <span class="title">주소 검색</span>
                    <daum-post-code :on-complete="handleAddress"></daum-post-code>
                </div>
            </div>
        </div>
        <contract-send-dlg
            v-if="contractSendPop"
            :show="contractSendPop"
            :info="contractSendInfo"
            :close="handleCloseContractSend"
            :charge="handleCharge"
            :paymentLinkSend="handlePaymentLinkSend"
        />

        <modal name="camera" :adaptive="true" :width="500" height="auto">
            <div class="container">
                <div slot="top-right">
                    <button class="close" @click="$modal.hide('camera')"></button>
                </div>

                <div class="title">사진촬영</div>

                <div style='display: flex; align-items: center; margin-bottom: 16px;'>
                    <web-cam
                        ref='webcam'
                        width='100%'
                        height='auto'
                        :selectFirstDevice='true'
                    />
                </div>

                <div style='display: flex; justify-content: space-between;'>
                    <span v-if='faceInProgress' class='app-txt'>처리중...</span>
                    <span v-else class="app-txt">
                        {{ customerInfo.doorRegStatus ? DOOR_REG_ERR_MSG[customerInfo.doorRegStatus] : '' }}
                    </span>

                    <button class="com-btn deep-blue" style='width: 160px; align-self: end;' @click="onTakePhoto">등록</button>
                </div>
            </div>
        </modal>
    </div>
</template>

<script>
import moment from 'moment';
import { WebCam } from "vue-web-cam";
import api from '@/assets/js/api';
import LoadingSpinner from '../../../components/LoadingSpinner';
import ContractSendDlg from '../../../components/ContractSendDlg';
import { validateTelNo } from '@/assets/js/validation';
import BtnLoadingSpinner from '../../../components/BtnLoadingSpinner';
import { MixinAllowedMenu } from '@/assets/js/mixinAllowedMenu';

export default {
    name: 'memberInfo',
    mixins: [MixinAllowedMenu],
    components: {
        LoadingSpinner,
        BtnLoadingSpinner,
        ContractSendDlg,
        WebCam,
    },
    props: {},
    computed: {
        fullPhoneNumber() {
            const ed = this.editField;
            return `${ed.phone[0]}${ed.phone[1]}${ed.phone[2]}`;
        },
        fullEmail() {
            const ed = this.editField;
            return `${ed.email[0]}@${ed.email[1]}`;
        },
        fullTaxTelNo() {
            const ed = this.editField;
            return `${ed.taxTelNo[0]}${ed.taxTelNo[1]}${ed.taxTelNo[2]}`;
        },
        cId() {
            return this.$store.getters['auth/cId'];
        },
        centerChains() {
            const { getters } = this.$store;
            return getters['auth/centerChains'];
        },
        isInsteadOfAdmin() {
            return this.$store.getters['auth/isInsteadOfAdmin'];
        },

        lastLessonDaysAgo() {
            if (this.customerInfo.latestLessonAt) {
                return moment().startOf('day').diff(moment(this.customerInfo.latestLessonAt).startOf('day'), 'days');
            }

            return '-';
        },
    },
    watch: {
        // 연락처와 동일 체크시
        equalPhoneAndTaxNo(val) {
            if (val) {
                const {
                    phone: [phoneFirst, phoneSecond, phoneThird],
                } = this.editField;
                const tempTaxTelNo = [phoneFirst, phoneSecond, phoneThird];
                this.editField.taxTelNo = tempTaxTelNo;
            }
        },
        password(val) {
            if (val.length > 0) {
                document.getElementById('password-notice').innerText = '';
            }
        },
    },
    created() {
        this.MEMO_MAX_LEN = 10000;

        this.DOOR_REG_ERR_MSG = {
            11: '얼굴을 인식할수 없습니다',
            12: '얼굴 너비가 기준을 만족하지 않습니다.',
            13: '얼굴 높이가 기준을 만족하지 않습니다.',
            14: '얼굴이 뚜렷하지 않습니다.',
            15: '얼굴 밝기가 기준을 만족하지 않습니다.',
            16: '얼굴 대조도가 기준을 만족하지 않습니다.',
        }
    },
    mounted() {
        this.init();
    },
    data() {
        return {
            hasMessageEvent: false, // 메시지 계약되었을시..

            postPop: false,
            isLoading: false,
            isProgressPhoneCheck: false, // 연락처 중복확인 진행중 Flag
            isProgressAttendNoCheck: false, // 출석체크번호 중복확인 진행중 Flag
            centerId: this.$route.params.id,
            customerId: this.$route.query.customerId,
            centerInfo: {}, // 센터 정보
            centerChainList: [], // 본점 + 지점 체인점 목록
            prevPagingStep: this.$route.query.prevPagingStep,
            isCheckedPhone: true, // 연락처 중복확인 여부
            showPhoneCheckMsg: '', // 연락처 중복확인 메세지 표시 여부 ( '' : 보이지 않음, true : 정상 메세지, false : 오류 메세지
            isCheckedAttendNo: true, // 출석체크번호 중복확인 여부
            showAttendNoCheckMsg: '', // 출석체크번호 중복확인 메세지
            equalPhoneAndTaxNo: false, // 연락처와 동일 체크 여부
            checkedPhoneNumber: '', // 중복확인 끝난 연락처
            checkedAttendNo: '', // 중복확인 끝난 출석체크번호

            editField: {
                appUseAuthYn: false,
                name: '',
                nickName: '',
                attendNo: '',
                parentTelNoYn: false, // 보호자 연락처 체크 여부
                phone: ['', '', ''],
                taxTelNo: ['', '', ''],
                email: ['', ''],
                password: '', // UI에 비밀번호 입력이 없음
                birthday: '',
                sex: '',
                imageFile: {
                    filename: '',
                    mimetype: '',
                    base64data: '',
                },
                imageUrl: '',
                mileage: 0,
                address: '',
                addressDetail: '',
                mktAgreeEmail: true,
                mktAgreeSms: true,
                mktAgreePush: true,
                memo: '',
                joinTermAgreeId: 0,
                centerCustomerTeams: [],
            },
            customerInfo: {},

            defaultImageUrl: '/img/icons/no_photo.jpg',
            emailTypeList: [...this.$emailType],
            emailTypeValueList: [...this.$emailType],

            memberGroupList: [],
            memberGroupValueList: [],

            selectedMemberGroup: [], // 회원이 속해있는 회원그룹 id값이 들어가는 배열

            chainCenterType: [], // 체인 센터명 배열
            chainCenterTypeValue: [], // 체인 센터 Id 배열

            password: '',

            contractSendPop: false,
            contractSendInfo: {},

            faceInProgress: false,
        };
    },
    methods: {
        initPassword() {
            if (this.password) {
                this.password.replaceAll(' ', '');
            } else {
                document.getElementById('password-notice').innerText = '비밀번호를 입력해 주세요';
                return;
            }
            if (confirm('센터회원의 비밀번호를 초기화 하시겠습니까?')) {
                this.isLoading = true;
                api.put(`/admin/api/center/${this.centerId}/customer/${this.customerId}/reset/pw`, {
                    centerId: this.centerId,
                    centerCustomerId: this.customerId,
                    password: this.password,
                })
                    .then((res) => {
                        this.isLoading = false;
                        this.password = '';
                        console.log(res.data);
                        alert('비밀번호가 변경되었습니다.');
                    })
                    .catch((e) => {
                        this.password = '';
                        this.isLoading = false;
                        alert('비밀번호 변경 도중 에러가 발생하였습니다.');
                    });
            }
        },

        showContractSendPopup() {
            this.contractSendInfo = {
                centerId: this.centerId,
                centerName: this.centerInfo.centerName,
                customerId: this.customerId,
                customerName: this.customerInfo.name,
                customerPhone: this.customerInfo.phone,
                templateType: 'M',
            };
            this.contractSendPop = true;
        },

        handleCloseContractSend() {
            this.contractSendPop = false;
        },

        handleCharge() {
            this.contractSendPop = false;
        },

        handlePaymentLinkSend() {
            this.contractSendPop = false;

            this.onClickRouter('/madmin/member/contract_send');
        },

        routing(toName, checkedUserData) {
            const routingData = [];
            console.log(checkedUserData);
            // checkedUserData.forEach((param) => {
            const tempValue = {
                ...checkedUserData,
            };
            routingData.push(tempValue);
            // });
            this.$router.push({
                name: toName,
                params: { data: routingData },
            });
        },

        checkMessageEvent() {
            return api
                .get('/admin/api/center/ftcontract/sms')
                .then((res) => {
                    this.hasMessageEvent = JSON.parse(res.data);
                })
                .catch((error) => {
                    this.hasMessageEvent = false;
                });
        },

        // 초기화
        async init() {
            this.isLoading = true;
            this.centerId = parseInt(this.cId, 10); // 로그인한 센터 id
            this.centerChainList = this.centerChains; // 체인점 최고 관리자는 centerChains 에 본점 + 지점 목록이 있음

            await Promise.allSettled([
                this.getCenterInfo(), // 로그인한 센터 정보 가져오기
                this.fetchCustomerDetail(), // 회원정보 가져오기
                this.fetchMemberGroupList(), // 회원그룹 가져오기
            ]);
            if (this.centerChainList.length === 0) {
                // 체인점 최고 관리자가 아닌 일반 센터 관리자 및 직원일 경우 접속한 아이디에 해당하는 센터만 센터 목록에 보임
                this.chainCenterType.push(this.centerInfo.centerName);
                this.chainCenterTypeValue.push(this.centerInfo.id);
                this.centerId = this.centerInfo.id;
            } else if (this.centerChainList.length !== 0) {
                // 체인점 최고 관리자일 경우 체인점에 속한 모든 센터가 목록에 보임
                this.centerChainList.forEach((c) => {
                    this.chainCenterType.push(c.centerName);
                    this.chainCenterTypeValue.push(c.centerId);
                    this.centerId = this.centerInfo.id; // 접속한 centerId가 기본으로 선택 되게끔 함
                });
            }

            if (!this.hasTeamIds(this.editField.centerCustomerTeams, this.memberGroupValueList)) {
                this.selectedMemberGroup = [];
            }
            await this.checkMessageEvent();
            this.isLoading = false;
        },

        // centerId 로 센터 정보 가져오기
        async getCenterInfo() {
            try {
                const { data } = await this.sendGetCenter();
                this.centerInfo = data;
            } catch (error) {
                console.log(error);
            }
        },

        // 센터 조회 API 호출
        sendGetCenter() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },
        // 센터회원 기본정보 가져오기
        async fetchCustomerDetail() {
            try {
                const { data } = await this.sendGetCustomerDetail();

                this.customerInfo = data;
                this.customerInfo.centerCustomerTeamGroups = this.customerInfo.centerCustomerTeamGroups.filter(
                    (g) => !g.centerCustomerTeam.info.deleteYn
                );

                const { editField } = this;
                editField.name = data.name;
                editField.nickName = data.nickName;
                editField.attendNo = data.attendNo;
                editField.parentTelNoYn = data.parentTelNoYn;
                editField.phone = this.splitPhoneNumber(data.phone);
                editField.taxTelNo =
                    data.taxTelNo === null || data.taxTelNo === ''
                        ? ['', '', '']
                        : this.splitPhoneNumber(data.taxTelNo);
                editField.email = this.splitEmail(data.email);
                editField.birthday = this.splitBirthday(data.birthday);
                editField.sex = data.sex;
                editField.address = data.address;
                editField.addressDetail = data.addressDetail;
                editField.mktAgreeEmail = data.mktAgreeEmail;
                editField.mktAgreeSms = data.mktAgreeSms;
                editField.mktAgreePush = data.mktAgreePush;
                editField.memo = data.memo;
                editField.imageUrl = data.imageUrl;
                editField.joinTermAgreeId = data.joinTermAgreeId;
                editField.password = data.password;
                editField.appUseAuthYn = data.appUseAuthYn;

                data.centerCustomerTeamGroups.forEach((d) => {
                    if (d.centerCustomerTeam.info.deleteYn) return;

                    const temp = {
                        centerCustomerTeamId: d.centerCustomerTeamId,
                        centerCustomerTeamName: d.centerCustomerTeamName,
                    };
                    this.selectedMemberGroup.push(d.centerCustomerTeamId);
                    this.editField.centerCustomerTeams.push(temp);
                });
            } catch (error) {
                alert('회원정보를 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원 기본정보 조회 API 호출
        sendGetCustomerDetail() {
            return api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}`);
        },

        // 센터회원팀 목록 조회
        async fetchMemberGroupList() {
            try {
                const { data } = await this.sendGetMemberGroupList();

                data.forEach((g) => {
                    this.memberGroupList.push(g.c_center_cust_team_nm);
                    this.memberGroupValueList.push(g.c_center_cust_team_id);
                });
            } catch (error) {
                console.log('회원그룹을 가져오는 중 오류가 발생했습니다.');
                console.log(error);
            }
        },

        // 센터회원팀 API 호출
        sendGetMemberGroupList() {
            return api.get(`/admin/api/center/${this.centerId}/customer-team`);
        },

        // 연락처 split
        splitPhoneNumber(phoneNumber) {
            if (!phoneNumber) return phoneNumber;

            phoneNumber = phoneNumber.replace(/[^0-9]/g, '');

            const tmp = ['', '', ''];
            if (phoneNumber.length < 4) {
                return phoneNumber;
            } else if (phoneNumber.length < 7) {
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3);
            } else if (phoneNumber.length == 8) {
                tmp[0] = phoneNumber.substr(0, 4);
                tmp[1] = phoneNumber.substr(4);
            } else if (phoneNumber.length < 10) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-123-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 3);
                    tmp[2] = phoneNumber.substr(5);
                }
            } else if (phoneNumber.length < 11) {
                if (phoneNumber.substr(0, 2) == '02') {
                    // 02-1234-5678
                    tmp[0] = phoneNumber.substr(0, 2);
                    tmp[1] = phoneNumber.substr(2, 4);
                    tmp[2] = phoneNumber.substr(6);
                } else {
                    // 010-123-4567
                    tmp[0] = phoneNumber.substr(0, 3);
                    tmp[1] = phoneNumber.substr(3, 3);
                    tmp[2] = phoneNumber.substr(6);
                }
            } else {
                // 010-1234-5678
                tmp[0] = phoneNumber.substr(0, 3);
                tmp[1] = phoneNumber.substr(3, 4);
                tmp[2] = phoneNumber.substr(7);
            }
            return tmp;
        },

        // 이메일 주소 Split
        splitEmail(email) {
            if (!email) return ['', ''];

            const tmp = ['', ''];
            tmp[0] = email.split('@')[0];
            tmp[1] = email.split('@')[1];
            return tmp;
        },

        // 생년월일 format '-'으로 변경
        splitBirthday(birthday) {
            if (birthday.length === 8) {
                return birthday.replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3');
            }
        },

        // 다음 주소 API 콜백
        handleAddress(data) {
            let fullAddress = data.address;
            let extraAddress = '';
            if (data.addressType === 'R') {
                if (data.bname !== '') {
                    extraAddress += data.bname;
                }
                if (data.buildingName !== '') {
                    extraAddress += extraAddress !== '' ? `, ${data.buildingName}` : data.buildingName;
                }
                fullAddress += extraAddress !== '' ? ` (${extraAddress})` : '';
            }
            this.editField.address = fullAddress; // e.g. '서울 성동구 왕십리로2길 20 (성수동1가)'
            this.postPop = false;
        },

        // Image 핸들러
        handleImage(e) {
            const selectedImage = e.target.files[0];
            this.editField.imageFile.filename = selectedImage.name;
            this.editField.imageFile.mimetype = selectedImage.type;
            this.createBase64Image(selectedImage);

            this.$refs.imageFileInput.reset();
        },

        // Base64 Image 생성
        createBase64Image(fileObj) {
            const reader = new FileReader();
            reader.onload = (e) => {
                this.registerFace(e.target.result)

                this.editField.imageUrl = e.target.result;
                this.editField.imageFile.base64data = this.editField.imageUrl.split(',')[1];
            };
            reader.readAsDataURL(fileObj);
        },

        // 이메일 select 변경시
        onChangeEmailSelect(val) {
            const temp = [this.editField.email[0], val];
            this.editField.email = temp;
        },

        // 페이지 이동
        onClickRouter(path, menu = '', eventNum = '') {
            this.$router.push({
                path: `${path}/${this.centerId}`,
                query: { customerId: this.customerId },
            });
        },

        // 목록 페이지로 이동
        onClickCancleBtn() {
            try {
                if (this.checkCheckTypeInLocalStorage()) {
                    this.$router.push({
                        path: '/madmin/course/care',
                        query: { prevPagingStep: this.prevPagingStep },
                    });
                } else {
                    this.$router.push({
                        path: '/madmin/member/list',
                        query: { prevPagingStep: this.prevPagingStep },
                    });
                }
            } catch (e) {
                this.$router.push({
                    path: '/madmin/member/list',
                    query: { prevPagingStep: this.prevPagingStep },
                });
            }
        },

        checkCheckTypeInLocalStorage() {
            const checkType = JSON.parse(localStorage.getItem('searchCondition')).checkType;
            if (checkType == '' || checkType == undefined || checkType == null) {
                return false;
            }
            return true;
        },

        // 회원그룹 체크시
        onChangeMemberGroup(val) {
            // 체크한 회원그룹 id값으로 회원그룹 이름을 찾기 위함
            this.editField.centerCustomerTeams = [];
            const findIndexList = [];
            val.forEach((v) => {
                const index = this.memberGroupValueList.findIndex((groupValue) => groupValue === v);
                findIndexList.push(index);
            });
            findIndexList.forEach((f) => {
                const temp = {
                    centerCustomerTeamId: this.memberGroupValueList[f],
                    centerCustomerTeamName: this.memberGroupList[f],
                };
                this.editField.centerCustomerTeams.push(temp);
            });
        },

        // 회원 정보 카드에 나타낼 회원 그룹 이름 만들기
        convertTeamGroupsToString(teamGroups) {
            if (teamGroups === undefined) {
                return;
            }
            if (teamGroups.length === 1) {
                // 그룹이 1개일 경우
                return teamGroups[0].centerCustomerTeamName;
            } else if (teamGroups.length === 0) {
                // 그룹이 없을 경우
                return '-';
            } else if (teamGroups.length > 1) {
                // 그룹이 여러개일 경우
                return `${teamGroups[0].centerCustomerTeamName} 외 ${teamGroups.length - 1}`;
            }
        },

        // 저장 버튼 클릭시
        async onClickModifyBtn() {
            try {
                const validate = this.validateValues();

                if (!validate.result) {
                    alert(validate.msg);
                    return false;
                }
                if (!confirm('회원정보를 수정하시겠습니까?')) {
                    return false;
                }
                this.isLoading = true;
                await this.sendPutCustomerDetail();
                alert('회원정보가 수정 되었습니다.');
                this.isLoading = false;
                if (this.checkCheckTypeInLocalStorage()) {
                    this.$router.push({
                        path: '/madmin/course/care',
                        query: { prevPagingStep: this.prevPagingStep },
                    });
                } else {
                    this.$router.push({
                        path: '/madmin/member/list',
                        query: { prevPagingStep: this.prevPagingStep },
                    });
                }
            } catch (error) {
                console.log(error);
                alert('저장 중 오류가 발생했습니다.');
                this.isLoading = false;
            }
        },

        async onClickEnableUser() {
            try {
                await api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}/reset/match`);
                alert('유저 활성화를 완료했습니다.');
            } catch (error) {
                alert('유저 활성화 중 오류가 생겼습니다.');
                this.isLoading = false;
            }
        },

        async onClickResetPassword() {
            try {
                await api.get(`/admin/api/center/${this.centerId}/customer/${this.customerId}/reset/pw`);
                alert('패스워드 초기화를 완료했습니다.');
            } catch (error) {
                alert('비밀번호 리셋 중 오류가 생겼습니다.');
                this.isLoading = false;
            }
        },

        async updateEmail() {
            try {
                await api.put(
                    `/admin/api/center/${this.centerId}/customer/${this.customerId}/email?email=${prompt('이메일')}`
                );
                alert('이메일 수정을 완료했습니다.');
            } catch (error) {
                alert('이메일 수정 중 오류가 생겼습니다.');
                this.isLoading = false;
            }
        },

        // 센터 회원 수정 API 호출
        sendPutCustomerDetail() {
            const params = this.getModifyParams();

            const { password, ...paramsWithoutPassword } = params;

            return api.put(`/admin/api/center/${this.centerId}/customer/${this.customerId}`, {
                ...paramsWithoutPassword,
            });
        },

        // 센터 회원 수정 파라미터 가공
        getModifyParams() {
            const {
                name,
                nickName,
                attendNo,
                parentTelNoYn,
                password,
                sex,
                imageFile,
                mileage,
                address,
                addressDetail,
                mktAgreeEmail,
                mktAgreeSms,
                mktAgreePush,
                memo,
                joinTermAgreeId,
                centerCustomerTeams,
            } = this.editField;
            const phone = this.fullPhoneNumber;
            const taxTelNo = this.fullTaxTelNo;
            const email = this.fullEmail;
            const birthday = this.editField.birthday.replace(/-/g, '');
            const params = {
                name,
                nickName,
                attendNo,
                parentTelNoYn,
                password,
                birthday,
                sex,
                imageFile,
                mileage,
                address,
                addressDetail,
                mktAgreeEmail,
                mktAgreeSms,
                mktAgreePush,
                memo,
                joinTermAgreeId,
                phone,
                taxTelNo,
                email,
                centerCustomerTeams,
            };
            if (imageFile.filename === '') {
                delete params.imageFile;
            }
            return params;
        },

        // 필수값 체크
        validateValues() {
            let result = false;
            const {
                name,
                nickName,
                sex,
                attendNo,
                phone: [phoneFirst, phoneSecond, phoneThird],
                email: [emailFirst, emailSecond],
                taxTelNo: [taxFirst, taxSecond, taxThird],
                password,
            } = this.editField;

            let msg = '';

            // 회원명
            if (name.trim() === '') {
                msg = '회원명을 입력하세요.';
                return {
                    result,
                    msg,
                };
            } else if (name.length === 1) {
                msg = '회원명을 다시 입력하세요.';
                return {
                    result,
                    msg,
                };
            }

            // 닉네임 길이 체크
            if (nickName && nickName.length === 1) {
                msg = '닉네임을 다시 입력하세요.';
                return {
                    result,
                    msg,
                };
            }

            // 성별
            if (sex.trim() === '') {
                msg = '성별을 선택하세요.';
                return {
                    result,
                    msg,
                };
            }

            // 연락처
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                msg = '연락처를 입력하세요.';
                return {
                    result,
                    msg,
                };
            }
            if (
                !validateTelNo(this.fullPhoneNumber) ||
                phoneFirst.length < 2 ||
                phoneSecond.length < 3 ||
                phoneThird.length != 4
            ) {
                msg = '연락처를 다시 확인하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (!this.isCheckedPhone) {
                msg = '연락처 중복확인을 해주세요.';
                return {
                    result,
                    msg,
                };
            }

            // 현금영수증 번호
            if (this.fullTaxTelNo.length > 0) {
                if (
                    !validateTelNo(this.fullTaxTelNo) ||
                    taxFirst.length < 2 ||
                    taxSecond.length < 3 ||
                    taxThird.length != 4
                ) {
                    msg = '현금영수증 번호를 다시 확인하세요.';
                    return {
                        result,
                        msg,
                    };
                }
            }

            // 출석체크번호
            if (attendNo.trim() === '') {
                msg = '출석체크번호를 입력하세요.';
                return {
                    result,
                    msg,
                };
            }
            if (attendNo.length < 4) {
                msg = '출석체크번호를 다시 확인하세요.';
                return {
                    result,
                    msg,
                };
            }

            if (!this.isCheckedAttendNo) {
                msg = '출석체크번호 중복확인을 해주세요.';
                return {
                    result,
                    msg,
                };
            }

            // 이메일
            // if( emailFirst.trim() === '' || emailSecond.trim() === ''){
            //     msg = '이메일을 입력하세요.';
            //     return { result, msg };
            // }
            // if( !validateEmail(this.fullEmail) || emailFirst.length < 3 || emailSecond.length < 6) {
            //     msg = '이메일을 다시 확인하세요.';
            //     return { result, msg };
            // }

            // 비밀번호
            // if( password.trim() === '') {
            //     msg = '비밀번호를 입력하세요';
            //     return { result, msg };
            // }
            // if( password.length < 8 ) {
            //     msg = '비밀번호를 8자리 이상 입력하세요.';
            //     return { result, msg };
            // }
            result = true;
            return { result };
        },

        // 연락처 중복확인 후 다시 수정할 경우 체크
        onChangePhoneNumber() {
            const { fullPhoneNumber } = this;
            switch (fullPhoneNumber) {
                case '':
                // case this.staffInfo.phone:
                case this.checkedPhoneNumber:
                    this.isCheckedPhone = true;
                    break;
                default:
                    this.isCheckedPhone = false;
                    this.showPhoneCheckMsg = '';
                    break;
            }
        },

        // 출석체크번호 중복확인 후 다시 수정할 경우 체크
        onChangeAttendNo() {
            const { attendNo } = this.editField;
            switch (attendNo) {
                case '':
                // case this.staffInfo.phone:
                case this.checkedAttendNo:
                    this.isCheckedAttendNo = true;
                    break;
                default:
                    this.isCheckedAttendNo = false;
                    this.showAttendNoCheckMsg = '';
                    break;
            }
        },

        // 연락처 중복 확인
        async checkDuplicatePhone() {
            const {
                phone: [phoneFirst, phoneSecond, phoneThird],
                parentTelNoYn,
            } = this.editField;
            // 연락처 입력 확인
            if (
                !validateTelNo(this.fullPhoneNumber) ||
                phoneFirst.length < 2 ||
                phoneSecond.length < 3 ||
                phoneThird.length < 4
            ) {
                alert('연락처를 다시 확인해주세요.');
                return;
            }
            if (phoneFirst.trim() === '' || phoneSecond.trim() === '' || phoneThird.trim() === '') {
                alert('연락처를 입력하세요.');
                return false;
            }

            this.isProgressPhoneCheck = true;
            this.showPhoneCheckMsg = '';
            const { data } = await this.sendGetDuplicatePhone(this.centerId, this.fullPhoneNumber, parentTelNoYn);

            if (!data) {
                this.isCheckedPhone = true;
                this.checkedPhoneNumber = this.fullPhoneNumber;
                this.editField.attendNo = phoneThird; // 연락처 마지막 4자리를 출석체크번호로 자동 입력
                this.showPhoneCheckMsg = true;
            } else {
                this.isCheckedPhone = false;
                this.checkedPhoneNumber = '';
                this.showPhoneCheckMsg = false;
            }
            this.isProgressPhoneCheck = false;
        },

        // 연락처 중복확인 API (중복이면 true)
        sendGetDuplicatePhone(centerId, phoneNumber, parentTelNoYn) {
            return api.get(`/admin/api/center/${centerId}/customer/phone/${phoneNumber}/duplicate`, {
                params: { parentTelNoYn },
            });
        },

        // 출석체크번호 중복 확인
        async checkDuplicateAttendNo() {
            this.showAttendNoCheckMsg = '';

            const { attendNo } = this.editField;

            // 출석체크번호 입력 확인
            if (attendNo.trim() === '') {
                alert('출석체크번호를 입력하세요.');
                return false;
            } else if (attendNo.length < 4) {
                alert('출석체크번호를 다시 확인하세요.');
                return false;
            }

            this.isProgressAttendNoCheck = true;
            const { data } = await this.sendGetDuplicateAttendNo(this.centerId, attendNo);

            if (!data) {
                this.isCheckedAttendNo = true;
                this.checkedAttendNo = attendNo;
                this.showAttendNoCheckMsg = true;
            } else {
                this.isCheckedAttendNo = false;
                this.checkedAttendNo = '';
                this.showAttendNoCheckMsg = false;
            }
            this.isProgressAttendNoCheck = false;
        },

        // 출석체크번호 중복확인 API (중복이면 true)
        sendGetDuplicateAttendNo(centerId, attendNo) {
            return api.get(`/admin/api/center/${centerId}/customer/attend-no/${attendNo}/duplicate`);
        },

        // 휴대폰 번호가 숫자인지 확인
        isNumber(evt) {
            evt = evt || window.event;
            const charCode = evt.which ? evt.which : evt.keyCode;
            if (charCode > 31 && (charCode < 48 || charCode > 57) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },

        // 생년월일 직접 입력시
        onChangeBirthDayTyping(e) {
            if (e.target.value.length < 8) {
                return;
            }
            this.editField.birthday = moment(e.target.value).format('YYYY-MM-DD');
            e.target.value = '';
        },
        hasTeamIds(teamIds, memberGroupValueList) {
            let answer = false;
            teamIds.forEach((i) => {
                memberGroupValueList.forEach((j) => {
                    if (i.centerCustomerTeamId === j) {
                        answer = true;
                    }
                });
            });
            return answer;
        },

        async onTakePhoto() {
            const imageData = this.$refs.webcam.capture();
            await this.registerFace(imageData);
        },

        async registerFace(imageData) {
            if (!this.centerInfo.activeDoorCount || !imageData) return;

            this.faceInProgress = true;

            try {
                const url = `/admin/api/center/${this.centerId}/door/face/${this.customerId}`
                await api.post(url, { face_template: imageData});

                setTimeout(async () => {
                    await this.fetchCustomerDetail();

                    this.faceInProgress = false;
                    if (this.customerInfo.doorRegStatus === 0) {
                        this.$modal.hide('camera')
                    }
                }, 3000);
            } catch (e) {
                this.faceInProgress = false;
                this.customerInfo.doorRegStatus = null;
            }
        },

        async deleteFace() {
            if (this.customerInfo.imageUrl == null) return;

            this.faceInProgress = true;

            try {
                const url = `/admin/api/center/${this.centerId}/door/face/${this.customerId}`
                await api.delete(url);

                setTimeout(async () => {
                    await this.fetchCustomerDetail();

                    this.faceInProgress = false;
                }, 3000);
            } catch (e) {
                this.faceInProgress = false;
            }
        }
    },
};
</script>

<style lang="scss" scoped>
.vm--modal {
    .container {
        display: flex;
        flex-direction: column;
        padding: 16px;
    }

    .title {
        padding-bottom: 10px;
        text-align: center;
        font-size: 20px;
        color: #0078f4;
    }

    .close {
        float: right;
        width: 20px;
        height: 20px;
        background: url(/img/icons/layerpop_square_close_btn.jpg) no-repeat 0 0;
        border: none;
    }

    .center {
        display: block;
        width: 100%;
        height: 56px;
        margin-top: 16px;
        border-radius: 0;
        border: 1px solid #e1e1e1;
        background: #f1f5f7;
        font-size: 16px;
        text-align: center;
        color: #7e7777;
    }
}
</style>
